import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import {Box} from '@mui/material';
import {  memo  , useCallback , useState, useRef} from 'react';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Button from '@mui/material/Button';
import { useTranslation } from "react-i18next";
import {nl2br} from "../constants.js";
import {getImagePaths , slickSettingsCard} from "../../components/constants.js";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import SlackImage from "../../components/modal/slackImage.js";
import ShareButtonX from "..//button/ShareButtonX.js";
import LinkCopyButton from "..//button/LinkCopyButton.js";


const MapCardBarrierFree = memo((props) => {
    const {data , resetMarker , isNarrowDown , toggleNarrowDown , modalOpen , returnUrl} = props;
    const [isOpenDescription , setIsOpenDescription] = useState(false);
    const { t } = useTranslation();

    //--- 画像モーダル
    const [showModal , setShowModal] = useState(false);
    const selectedSlackImgUrl = useRef(null);
    const openSlackModal = (index, url) => {
        selectedSlackImgUrl.current = url;
        setShowModal(true);
    };
    const closeSlackModal = (index, url) => {
        selectedSlackImgUrl.current = "";
        setShowModal(false);
    };
    // 画像モーダル ---*/

    const toggleOpenDescription = () => {
        setIsOpenDescription(!isOpenDescription);
    };
    const close = () => {
        setIsOpenDescription(false);
        resetMarker();
    }
    const clickBtnNarrow = () => {
        toggleNarrowDown(!isNarrowDown);
    }

    const nl2comma = useCallback((str) => {
        return str.replaceAll("¥/", "、");
    },[]);

    const canDisplayDescription = useCallback((barrierFree) => {
        if(!barrierFree){
            return false;
        }
        return barrierFree.description !== '';
    },[]);

    if(data && data.name){
    let paths = getImagePaths(data.path);
    return <>
    <Card className={"barrierFreeCard mapCard"} sx={{
       position: 'absolute',
       bottom: '1%',
       right:'1%',
       width:'98%',
       zIndex:10000     
    }}>
    <Box className='head-content'>
        <Typography component="div" variant="h5" className="title">
            {data.name}
        </Typography>
        <IconButton className={"close"} size="large">
            <CloseIcon onClick={close} />
        </IconButton>
    </Box>
    <Box className="share-button-row">
        <span className='category-label text'>{t("category." + data.category)}</span>
        <div className="img-wap">
            <ShareButtonX 
                path={returnUrl()}
                text={data.name + ' / ' + t("meta.title")}
            />
            <LinkCopyButton 
                path={returnUrl()}
            />
        </div>
    </Box>
    <hr className={"hr95"} />

    <Box sx={{display:'flex'}}>
        <Box sx={{ display: 'block'}}>
            <CardContent className="card-content" sx={{ flex: '1 0 auto' }}>
               <div className="slick-wrap">
                    {paths.length >= 1 &&
                    <Slider {...slickSettingsCard}>
                    {
                        paths.map((path, index) =>{
                            return <Box className="img-carousel-wrap" key={index} onClick={() => openSlackModal(index, "/assets/images/descriptions/" + path)}>
                                <img className="img-carousel" src={"/assets/images/descriptions/" + path} />
                                </Box>
                        })
                    }
                    </Slider>
                    }
                </div>
                <Typography variant="subtitle1" component="div" sx={{ color: 'text.secondary', overflowWrap: 'break-word' }}>
                    <div dangerouslySetInnerHTML={{__html: nl2br(data.catchcopy)}}></div>
                </Typography>

                {modalOpen && data.insta360 && 
                <Box className='btnWrap'>
                    <Button variant="contained" onClick={modalOpen}>{t("360image.button")}</Button>
                </Box>
                }

                {canDisplayDescription(data) &&
                <>
                <hr className={"hr98 mtb10"} />
                <Box className='description'>
                    <div dangerouslySetInnerHTML={{__html: nl2br(data.description)}}></div>
                </Box>
                </>
                }
            </CardContent>
        </Box>
    </Box>

    <Box className='btnWrap'>
        {false && 
        <Button variant="contained" onClick={clickBtnNarrow}>
            {isNarrowDown?<>{t("common.btn_narrow_off")}</>:<>{t("common.btn_narrow_on")}</>}
        </Button>
        }
    </Box>
    </Card>
    {showModal &&
        <SlackImage isOpen={showModal} modalClose={closeSlackModal} url={selectedSlackImgUrl.current}></SlackImage>
    }  
    </>;
    }
});
export default MapCardBarrierFree
